import { Component } from '@angular/core';

@Component({
  selector: 'app-landing-route',
  standalone: true,
  template: '',
})
export class LandingRouteComponent {}
